export default __webpack_public_path__ + "static/media/480_business05-nl-mobile.f2a17063.png";